module.exports = "https://static.zego.com/_next/static/images/founder-harry-c396ef52b2c1e0498ee5b36d715d84f9.jpg";